export const TOUR_CARD_READ_EVENT_NAME = 'tour_card_read';
export const STEP_2_CARD = 'Step #2';
